// @flow
import {
    REQUEST_TEAM_LIST,
    REQUEST_TEAM_LIST_SUCCESS,
    REQUEST_TEAM_LIST_FAILED,
    REQUEST_TEAM_APPROVE,
    REQUEST_TEAM_APPROVE_SUCCESS,
    REQUEST_TEAM_APPROVE_FAILED,
    REQUEST_TEAM_REJECT,
    REQUEST_TEAM_REJECT_SUCCESS,
    REQUEST_TEAM_REJECT_FAILED,
    REQUEST_TEAM_DELETE,
    REQUEST_TEAM_DELETE_SUCCESS,
    REQUEST_TEAM_DELETE_FAILED,
} from './constants';

import { getLoggedInUser } from '../../helpers/authUtils';

const INIT_STATE = {
    user: getLoggedInUser(),
    loading: false,
};

type RequestTeamAction = { type: string, payload: {} | string };
type State = { user?: {} | null, loading?: boolean, +value?: boolean };

const RequestTeam = (state: State = INIT_STATE, action: RequestTeamAction) => {
    switch (action.type) {
        case REQUEST_TEAM_LIST:
            return { ...state, listloading: true };
        case REQUEST_TEAM_LIST_SUCCESS:
            return { ...state, request: action.payload, listloading: false, error: null };
        case REQUEST_TEAM_LIST_FAILED:
            return { ...state, error: action.payload, loading: false };

        case REQUEST_TEAM_APPROVE:
            return { ...state, loading: true };
        case REQUEST_TEAM_APPROVE_SUCCESS:
            return { ...state, requestApprove: action.payload, loading: false, error: null };
        case REQUEST_TEAM_APPROVE_FAILED:
            return { ...state, error: action.payload, loading: false };

        case REQUEST_TEAM_REJECT:
            return { ...state, loading: true };
        case REQUEST_TEAM_REJECT_SUCCESS:
            return { ...state, requestReject: action.payload, loading: false, error: null };
        case REQUEST_TEAM_REJECT_FAILED:
            return { ...state, error: action.payload, loading: false };

        case REQUEST_TEAM_DELETE:
            return { ...state, loading: true };
        case REQUEST_TEAM_DELETE_SUCCESS:
            return { ...state, requestDelete: action.payload, loading: false, error: null };
        case REQUEST_TEAM_DELETE_FAILED:
            return { ...state, error: action.payload, loading: false };
        default:
            return { ...state };
    }
};

export default RequestTeam;
